"use client"

import React, { createContext, useContext, useState, useEffect, useRef, ReactNode } from 'react'

interface SelectionModeContextType {
  isSelectionModeActive: boolean
  setSelectionModeActive: (active: boolean) => void
}

const SelectionModeContext = createContext<SelectionModeContextType | undefined>(undefined)

export function SelectionModeProvider({ children }: { children: ReactNode }) {
  const [isSelectionModeActive, setSelectionModeActive] = useState(false)
  const mountedRef = useRef(false)

  useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return
    const wrapped = (active: boolean) => {
      if (mountedRef.current) setSelectionModeActive(active)
    }
    ;(window as any).__setSelectionModeActive = wrapped
    return () => {
      delete (window as any).__setSelectionModeActive
    }
  }, [])

  return (
    <SelectionModeContext.Provider value={{ isSelectionModeActive, setSelectionModeActive }}>
      {children}
    </SelectionModeContext.Provider>
  )
}

export function useSelectionMode() {
  const context = useContext(SelectionModeContext)
  if (context === undefined) {
    throw new Error('useSelectionMode must be used within a SelectionModeProvider')
  }
  return context
}
